import { AvailabilityStatus } from '@app/types/availability/enums'

import type { AvailabilityApiResponse, UpdateAvailabilityPayload } from '@app/types/profile/interfaces'

import { useProfileStore } from '@stores/profile'

import { useAdminRoutes } from '@composables/routes/admin-route.hook'

import { getAxiosErrorMessage } from '@helpers/axios'

import { useToast } from '@UI/Toast/ToastProvider'

export const useAvailabilityUpdate = async (availability: boolean): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const profileStore = useProfileStore()

  const url = useAdminRoutes('admin.profile.availability')

  if (!url) {
    toast.error('Unexpected error. Invalid request URL.')
    return false
  }

  try {
    const payload: UpdateAvailabilityPayload = { availability }
    const { data } = await $axios.patch<AvailabilityApiResponse>(url, payload)

    if (!data.success || !data.data) {
      toast.error(data.message)
      return false
    }

    profileStore.setSlot(data.data)
    toast.success(`Your status is ${data.data.availability ? AvailabilityStatus.Available : AvailabilityStatus.Unavailable}`)

    return true
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return false
  }
}
